import { render, staticRenderFns } from "./BulkButton.vue?vue&type=template&id=47def4cf&"
import script from "./BulkButton.vue?vue&type=script&lang=ts&"
export * from "./BulkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports